<div class="row">
  <div class="col-sm-12">
    <form id="observacoesDocForm" autocomplete="off" [formGroup]="observacoesDocForm">
      <div class="row row-cols-1">
        <div class="col form-group my-2">
          <label for="nomeDocumento" class="form-label">Nome do documento</label>
          <nz-input-group nzSize="large">
            <input nz-input id="nomeDocumento" formControlName="nomeDocumento" placeholder="Nome do documento" />
          </nz-input-group>
          <ng-template #nomeTemplate>
            <span class="fs-5 me-2 clarity--user-solid"></span>
          </ng-template>
        </div>
        <div class="col form-group my-2">
          <label for="tipoDocumentoId" class="form-label">Tipo Documento</label>
          <nz-select formControlName="tipoDocumentoId" nzShowSearch nzAllowClear nzPlaceHolder="Tipo Documento"
            nzSize="large" [compareWith]="compareFn">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoDocumento" *ngFor="let item of tipoDocumentoList" />
          </nz-select>
        </div>
        <!-- <div class="col form-group my-2">
          <label for="pais" class="form-label">Observações</label>
          <nz-textarea-count [nzMaxCharacterCount]="100">
            <textarea rows="6" formControlName="observacoesDoc" nz-input></textarea>
          </nz-textarea-count>
        </div> -->
        <div class="col form-group my-2">
          <label for="arquivos" class="form-label">Enviar Arquivos</label>

          <ng-container *ngIf="arquivos.length == 0">
            <app-upload-arquivo [arquivos]="arquivos" [limite]="10" nz-tooltip [tiposArquivos]="isFileTypeAccepted"
              nzTooltipTitle="Arquivo"></app-upload-arquivo>
          </ng-container>

          <ng-container *ngIf="arquivos.length > 0">
            <div class="col-12 rounded-3 border p-3">
              <div class="row">
                <div class="col-8 d-flex align-items-center">
                  {{ arquivoRecebido?.nome }}
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end">
                  <button nz-button nzType="primary" nz-popover
                  nzPopoverContent="Delete" nzPopoverPlacement="top" (click)="removerArquivo()">
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </form>
  </div>
  <div class="row mt-4">
    <div class="col-12 d-flex justify-content-end">
      <button nz-button nzType="primary" (click)="handleOk()">{{ inserir ? 'Adicionar' : 'Editar' }}</button>
      <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
    </div>
  </div>
</div>
